import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqItem, HELP_FAQS } from '../help-faqs.data';

@Component({
  selector: 'app-help-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './help-faq.html',
  styleUrl: './help-faq.css',
})
export class HelpFaqComponent {
  @Input() searchTerm = '';

  faqs: FaqItem[] = HELP_FAQS;

  get filteredFaqs(): FaqItem[] {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) {
      return this.faqs;
    }
    return this.faqs.filter(
      (faq) => faq.question.toLowerCase().includes(term) || faq.answer.toLowerCase().includes(term)
    );
  }

  toggleFaq(faq: FaqItem): void {
    faq.open = !faq.open;
  }
}
